class AnnouncementBar extends HTMLElement {

  constructor() {
    super();
    this._items = [];
    this._currentStep = 0;
    this._timer = null;
    this._perView = 1;
    this._mqMdlg = null;
    this._mqMd = null;
    this._onMqChangeBound = this._onMqChange.bind(this);
  };

  connectedCallback() {
    this._items = Array.from(this.querySelectorAll('.announcement-bar__item'));
    if (!this._items.length) return;

    this._prevBtn = this.querySelector('.announcement-bar__arrow--prev');
    this._nextBtn = this.querySelector('.announcement-bar__arrow--next');
    if (this._prevBtn) this._prevBtn.addEventListener('click', () => this._step(-1));
    if (this._nextBtn) this._nextBtn.addEventListener('click', () => this._step(1));

    const bp = window.umbrellaConfig?.breakpoints ?? { md: 768, lg: 1200 };
    this._mqMdlg = window.matchMedia(`(min-width: ${bp.lg}px)`);
    this._mqMd = window.matchMedia(`(min-width: ${bp.md}px)`);
    this._mqMdlg.addEventListener('change', this._onMqChangeBound);
    this._mqMd.addEventListener('change', this._onMqChangeBound);

    this._onMqChange();
  };

  disconnectedCallback() {
    this._stop();
    if (this._mqMdlg) this._mqMdlg.removeEventListener('change', this._onMqChangeBound);
    if (this._mqMd) this._mqMd.removeEventListener('change', this._onMqChangeBound);
  };

  _onMqChange() {
    this._stop();
    if (this._mqMdlg && this._mqMdlg.matches) {
      // Static mode: clear all inline styles and let CSS/media query take over
      this._items.forEach((item) => {
        item.style.opacity = '';
        item.style.pointerEvents = '';
      });
    } else {
      this._perView = (this._mqMd && this._mqMd.matches) ? 2 : 1;
      // Set active items inline BEFORE starting the cycle so the
      // initial state matches the pre-JS :first-child CSS exactly.
      this._currentStep = 0;
      this._showStep(0);

      const steps = Math.ceil(this._items.length / this._perView);
      if (steps <= 1) return;

      const interval = parseInt(this.dataset.interval) || 3000;
      this._timer = setInterval(() => {
        this._currentStep = (this._currentStep + 1) % steps;
        this._showStep(this._currentStep);
      }, interval);
    };
  };

  _showStep(step) {
    const start = step * this._perView;
    const end = start + this._perView;
    // Inline styles beat all CSS specificity, cleanly overriding the
    // pre-JS :first-child/:nth-child rules without needing !important.
    this._items.forEach((item, i) => {
      const active = i >= start && i < end;
      item.style.opacity = active ? '1' : '0';
      item.style.pointerEvents = active ? 'auto' : 'none';
    });
  };

  _step(delta) {
    if (this._mqMdlg && this._mqMdlg.matches) return;
    const steps = Math.ceil(this._items.length / this._perView);
    if (steps <= 1) return;
    this._currentStep = (this._currentStep + delta + steps) % steps;
    this._showStep(this._currentStep);
    if (this._timer) {
      clearInterval(this._timer);
      const interval = parseInt(this.dataset.interval) || 3000;
      this._timer = setInterval(() => {
        this._currentStep = (this._currentStep + 1) % steps;
        this._showStep(this._currentStep);
      }, interval);
    };
  };

  _stop() {
    if (this._timer) {
      clearInterval(this._timer);
      this._timer = null;
    };
  };

};

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar);
};
